import styled from "styled-components"

export const SuccessMessage = styled.p`
    color: green;
    font-size: 16px;
    text-align: center;
`